import { useState, useContext } from 'react';
import { X, Pause, AlertTriangle } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function PausePublicationModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handlePausePublication = async () => {
    setIsLoading(true);
    
    try {
      const result = await auditPlanService.pausePublicationAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess(result.message || 'Publication paused successfully');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Failed to pause publication');
      }
    } catch (error) {
      console.error('Error pausing publication:', error);
      showError('An error occurred while pausing publication');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <Pause className="h-5 w-5 mr-2 text-orange-600" />
            Suspendre la publication
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            disabled={isLoading}
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="mb-6">
          <div className="flex items-start space-x-3 p-4 bg-orange-50 border border-orange-200 rounded-lg">
            <AlertTriangle className="h-5 w-5 text-orange-600 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-orange-800">
                Suspendre la publication
              </p>
              <p className="text-sm text-orange-700 mt-1">
                Cela suspendra la publication de ce plan d'audit. Le plan ne sera plus visible pour les parties du programme d'audit. Vous pourrez le publier à nouveau plus tard pour le rendre visible.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Annuler
          </button>
          <button
            onClick={handlePausePublication}
            disabled={isLoading}
            className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          >
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Suspension en cours...
              </>
            ) : (
              <>
                <Pause className="h-4 w-4 mr-2" />
                Suspendre la publication
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}